import type { Message } from "../types";
import { toUnixMs } from "../utils/timestamps";

/** A server update must not roll back a newer edit or erase decrypted content. */
export function mergeMessages(existing: Message[], incoming: Message[]): Message[] {
  const byId = new Map(existing.map((message) => [message.id, message]));
  for (const message of incoming) {
    const local = byId.get(message.id);
    if (local && toUnixMs(local.updatedAt) > toUnixMs(message.updatedAt) &&
        local.status !== "sending" && local.status !== "failed") continue;
    const keepPlaintext = local?.isEncrypted && message.isEncrypted && !message.isDeleted &&
      local.encryptedEnvelope === message.encryptedEnvelope && local.content.type !== "encrypted";
    byId.set(message.id, keepPlaintext ? { ...message, content: local.content } : message);
  }
  return [...byId.values()].sort((a, b) => toUnixMs(a.createdAt) - toUnixMs(b.createdAt) || a.id.localeCompare(b.id));
}

export function isMessageVisible(message: Message, now = Date.now()): boolean {
  return !message.isDeleted && !(message.expiresAt && message.expiresAt * 1000 <= now);
}
